module.exports = __webpack_public_path__ + "img/Om.46c35aa6.jpg";